export const tokenUtils = {
  methods: {
    parseJwt (token) {
      let base64Url = token.split('.')[1]
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      let jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      return JSON.parse(jsonPayload)
    },
    getGreekName (token) {
      let tokenParsed = this.parseJwt(token)

      if (tokenParsed.hasOwnProperty('name')) {
        let name = tokenParsed.name

        return name
          .match(/\p{sc=Greek}|\p{Zs}/gu) // Match Greek unicode characters and whitespaces
          .join('')
          .replace(/ \s{2,}/g, ' ') // Remove double or more whitespaces
          .replace(/^\s+|\s+$/g, '') // Remove leading and trailing whitespaces
      } else {
        return null
      }
    },
    getLatinName (token) {
      let tokenParsed = this.parseJwt(token)

      if (tokenParsed.hasOwnProperty('name')) {
        let name = tokenParsed.name

        return name
          .replace(/\p{sc=Greek}/gu, '') // Remove Greek unicode characters
          .replace(/,/g, '') // Remove the commas
          .replace(/ \s{2,}/g, ' ') // Remove double or more whitespaces
          .replace(/^\s+|\s+$/g, '') // Remove leading and trailing whitespaces
      } else {
        return null
      }
    },
    getAuthSource (token) {
      let authSource = 'eIDAS eID'
      let tokenParsed = this.parseJwt(token)
      if (tokenParsed.hasOwnProperty('auth-source')) {
        authSource = tokenParsed['auth-source']
      }
      return authSource
    }
  }
}
